import { Link } from 'react-router-dom';
import { GenericCatalogTable } from "../../../components/generic-catalog-table";
import { ScrollReveal } from "../../../components/scroll-reveal";
import { NIST_CSF_CATALOG, NIST_CSF_FUNCTIONS } from "../../../data/nist-csf-controls";

export default function NistCsfFramework() {
  const columns = [
    { accessorKey: "function", header: "Function", size: 160 },
    { accessorKey: "category", header: "Category", size: 220 },
    { accessorKey: "subcategory", header: "Subcategory", size: 140 },
    { accessorKey: "description", header: "Description", size: 320 },
    { accessorKey: "implementationTier", header: "Implementation Tier", size: 160 },
    { accessorKey: "informativeReferences", header: "Informative References", size: 220 },
    { accessorKey: "indianMapping", header: "Indian Mapping", size: 220 },
    { accessorKey: "technologyEnablers", header: "Technology Enablers", size: 220 },
  ];
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            International Frameworks / NIST CSF
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            NIST Cybersecurity Framework 2.0
            <br />
            Risk-Based Security Management
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            The most widely adopted cybersecurity framework globally, now enhanced with Govern function and supply chain focus.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#nist-csf-catalog"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Download Function Mapping
            </a>
            <a
              href="#tiers"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              View Implementation Tiers
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold text-[color:var(--text-link)] transition-colors hover:text-text-primary"
            >
              Back to India →
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Functions", v: "6" },
              { k: "Categories", v: "22" },
              { k: "Subcategories", v: "108" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">{s.k}</div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="tiers">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="glass-card p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Functions (2.0)</div>
              <h2 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">6 functions</h2>
              <div className="mt-6 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {NIST_CSF_FUNCTIONS.map((f) => (
                  <div key={f.code} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-3">
                    <div className="text-sm font-semibold text-text-primary">{f.name} ({f.code})</div>
                    <div className="mt-1 text-sm text-text-secondary">{f.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="bg-background-primary py-20" id="nist-csf-catalog">
        <div className="container-ivalue">
          <ScrollReveal>
            <div>
              <h2 className="text-3xl font-extrabold tracking-[-0.02em] text-text-primary md:text-5xl">NIST CSF 2.0 control catalog</h2>
              <p className="mt-3 max-w-3xl text-lg text-text-secondary">
                Seeded with representative subcategories (expandable to the full 108).
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-10">
            <GenericCatalogTable
              data={NIST_CSF_CATALOG}
              columns={columns}
              csvColumns={[
                { header: "Function", accessorKey: "function" },
                { header: "Category", accessorKey: "category" },
                { header: "Subcategory", accessorKey: "subcategory" },
                { header: "Description", accessorKey: "description" },
                { header: "Tier", accessorKey: "implementationTier" },
                { header: "References", accessorKey: "informativeReferences" },
                { header: "Indian Mapping", accessorKey: "indianMapping" },
                { header: "Tech", accessorKey: "technologyEnablers" },
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
